import appAxios from 'voxguru-v1/api/appAxios';

const makeGetRequest = async (endpoint) => {
  const { data } = await appAxios.get(endpoint);
  return data;
};

export default makeGetRequest;
